import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { Toastr, tools } from 'data/common';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Add as AddIcon, Refresh as RefreshIcon, RemoveRedEye as ViewIcon, Delete as DeleteIcon } from '@material-ui/icons';
import memoizeOne from 'memoize-one';
import Translator from '../../../../../../translator';
import FHETable from '../../../../data/components/FHETable';
import getSelectors from '../Home/selectors';
import { getBrands, deleteBrand } from '../../data/Brands/actions';

class Brands extends PureComponent {
    static propTypes = {
        getBrands: PropTypes.func.isRequired,
        Brands: PropTypes.object.isRequired,
        deleteBrand: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        classes: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        const { initialized } = props;

        this.state = {
            loading: !initialized,
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) {
            this.refreshBrands();
        }
    }

    refreshBrands = () => {
        const { getBrands } = this.props;
        this.setState({ loading: true }, () => {
            return getBrands()
                .catch(err => {
                    const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                    Toastr.error(message);
                })
                .finally(() => {
                    this.setState({ loading: false });
                });
        });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `brands/detail/${rowData.id}` });
    };
    navigateToAdd = () => {
        const { history } = this.props;
        return history.push({ pathname: 'brands/add' });
    };

    confirmDeleteBrand = (row, callbackRowActionLoading) => {
        if (row.nbrUser === 0) {
            callbackRowActionLoading(true);
            Toastr.confirm(
                Translator.translate('generic.brands.actions.deleteConfirm', row.title),
                Translator.translate('general.logout.confirmationTitle'),
                {
                    onYes: () => {
                        this.handleDelete(row, callbackRowActionLoading);
                    },
                    onNo: () => {
                        callbackRowActionLoading(false);
                    },
                },
            );
        } else {
            Toastr.warning('Vous ne pouvez pas supprimer une marque avec des utilisateurs assignés');
        }
    };

    handleDelete = (row, callbackRowActionLoading) => {
        const { deleteBrand } = this.props;

        deleteBrand(Number(row.id))
            .then(() => {
                const message = Translator.translate('generic.brands.actions.deleteSuccess', row.title);
                Toastr.success(message);
            })
            .catch(() => {
                const message = Translator.translate('generic.brands.actions.deleteError', row.title);
                Toastr.error(message);
            })
            .finally(() => callbackRowActionLoading(false));
    };

    renderActions = memoizeOne(profile => {
        const { history } = this.props;

        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`generic.brands.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshBrands,
                },
            ],
        };
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeAdd')) {
            actions.toolbar.push({
                icon: AddIcon,
                tooltip: Translator.translate(`generic.brands.table.globalAction.add.tooltip`),
                onClick: this.navigateToAdd,
            });
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`),
            });
        }
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeDetails')) {
            actions.row.push({
                icon: () => <DeleteIcon />,
                onClick: (row, callbackRowActionLoading) => this.confirmDeleteBrand(row, callbackRowActionLoading),
                tooltip: Translator.translate(`general.delete`),
            });
        }
        return actions;
    });

    renderData = memoizeOne(Brands => {
        let result = [];
        Brands.map((Brand, BrandId) => {
            result.push({
                id: parseInt(BrandId),
                label: Brand.get('title'),
                key: Brand.get('key'),
                nbrUser: Brand.get('nbrUser') ? parseInt(Brand.get('nbrUser')) : 0,
            });
        });
        return result;
    });

    renderColumns = memoizeOne(() => {
        return [
            {
                title: Translator.translate(`general.table.column.id`),
                name: 'id',
                width: 90,
                fixedLeft: true,
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                width: 90,
                defaultSort: 'desc',
            },
            {
                title: Translator.translate('general.table.column.key'),
                name: 'key',
                width: 90,
                defaultSort: 'desc',
            },
            {
                title: Translator.translate('general.table.column.nbrUser'),
                name: 'nbrUser',
            },
        ];
    });
    render() {
        const { loading } = this.state;
        const { profile, Brands } = this.props;

        return (
            <FHETable
                idTable="brandList"
                columns={this.renderColumns()}
                data={this.renderData(Brands)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`generic.brands.table.title`)}
                emptyDataSourceMessage={Translator.translate(`generic.home.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

const styles = theme => ({});

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        initialized: selectors.getHomesInitialized(state),
        profile: selectors.getProfile(state),
        Brands: selectors.getBrands(state),
    };
}
export default withRouter(
    renderEnvComponent(
        'scenes/Brands/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getBrands, deleteBrand }), dispatch),
        )(withStyles(styles, { withTheme: true })(Brands)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Brands/index.js